export const PARKING_PRICES = Object.freeze({
  moto: 5000,
  auto: 10000,
});

export function getParkingPrice(vehicleType, tariff) {
  return tariff?.vehicle_prices?.[vehicleType]
    ?? PARKING_PRICES[vehicleType]
    ?? PARKING_PRICES.auto;
}
